/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBorderCornerPill = createReactComponent(
  "border-corner-pill",
  "IconBorderCornerPill",
  [["path", { d: "M4 20v-5c0 -6.075 4.925 -11 11 -11h5", key: "svg-0" }]]
);

export { IconBorderCornerPill as default };
//# sourceMappingURL=IconBorderCornerPill.js.map
